module.exports = __webpack_public_path__ + "img/calculator.51348b45.png";